






import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { IBrand } from '~/assets/interfaces/brands'

@Component
export default class ComponentBrandItemText extends Vue {
  @Prop({
    type: Object,
    default: () => {},
  })
  readonly item!: IBrand
}
